module.exports = __webpack_public_path__ + "img/AT0000002606901.853532a1.png";